var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-linkbutton"},[_c('a',{staticClass:"c-linkbutton-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }